module.exports = __webpack_public_path__ + "img/es.0e1bf167.png";